<template>
    <div>
      <v-navigation-drawer
        stateless
        :value="drawer"
        temporary
        mobile-break-point="1170"
        app
        class="nav-drawer"
      >

   <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
           <div class="toolbar__title text-xs-center">BOP</div>
          </v-list-tile-title>
          <v-btn icon @click="updateDrawerState(false)" ><v-icon>close</v-icon></v-btn>
        </v-list-tile>
      </v-list>
    </v-toolbar>

      <v-list>
        <v-list-group
              v-for="item in navitems"
              :key="item.title"
              v-model="item.active"
              no-action
        > <!-- group1 -->

          <v-list-tile slot="activator" @click="updateDrawerState(false)" :to="{name: item.linkName, params: item.params ? item.params : {} }">
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

           <v-list-group
            v-for="subitem in item.items"
            :key="subitem.title"
            v-model="subitem.active"
              no-action
              sub-group
            > <!-- group2 -->

              <v-list-tile slot="activator" @click="updateDrawerState(false)"  :to="{name: subitem.linkName, params: subitem.params ? subitem.params : {} }">
                <v-list-tile-content>
                  <v-list-tile-title>{{subitem.title}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                v-for="subitem2 in subitem.items"
                :key="subitem2.title"
                v-model="subitem2.active"
                @click="updateDrawerState(false)"
                :to="{name: subitem2.linkName, params: subitem2.params ? subitem2.params : {} }"
              > <!-- level3 -->
                <v-list-tile-content>
                  <v-list-tile-title>{{subitem2.title}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile> <!-- fin level3 -->

             </v-list-group><!-- fin group2 -->

        </v-list-group><!-- fin group1 -->
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState ({
        drawer: state => state.navigation.sidebarIsActive,
        navitems: state => state.navigation.navitems
    }),
    ...mapGetters('navigation', {
      sidebarIsActive: 'sidebarIsActive'
    })
  },
  methods: {
    ...mapActions ('navigation', {
        updateDrawerState: 'setSidebarState'
    }),
    updateDrawerStates2:  function(isActive) {
    }
  }
};

</script>

<style lang="scss">
.nav-drawer {
  z-index: 200;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/SideNav.vue